import React, { useEffect, useState } from "react";
import MyContext from "../../../../../api/context/my-context";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

/**
 * @returns contex'i döndürür
 */
function useContext() {
  const context = React.useContext(MyContext.Consumer);
  if (context === undefined) {
    throw new Error("useCount must be used within a CountProvider");
  }
  return context;
}

const ActiveerMaatregelModal = () => {
  var context = useContext();

  useEffect(() => {
    // uygulama ilk çalıştığında waitProcess state'lerini temizliyoruz
    context.actions.actionStartProcess(null);
    // returned function will be called on component unmount
    // bu fonksiyon class compnent'teki  "componentWillMount()" gibi çalışır
    return () => {
      context.actions.actionStartProcess(null);
    };
  }, []);

  var selectedRowDefinition = [];

  const handleSubmit = async () => {
    selectedRowDefinition = [];

    $("#cover-spin").show(0);
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });
    /**
     * * process kontrol için 1. adım
     * * kayıttan önce tüm satırların stagelistleri alınır.
     */

    for (let i = 0; i < selectedIds.length; i++) {
      const id = selectedIds[i];

      for (let j = 0; j < window.$mm_work_plans_Glist.length; j++) {
        const rowList = window.$mm_work_plans_Glist[j];
        if (id == rowList.identification) {
          /**
           * * seçilmiş satırların sırası ile stage listleri çekilir
           */
          await omnimap
            .GetActionsOfRowSingleAction(id, window.$mm_management_units_token)
            .then(async (result) => {
              const listItem = {
                stageList: result.data.stages_list,
                id: id,
                rowItem: rowList,
              };
              selectedRowDefinition.push(listItem);
            });
          break;
        }
      }
    }
    var model = {
      action: "PUSH",
      informatie:
        "Door op 'Verwerken' te klikken zal de werkregel naar de Gisratio app verstuurd worden.",
    };

    await GC.StartActivity(
      model,
      selectedIds,
      "56785c54-8059-46ae-8b7f-250ce971a539",
      WijzigStatusSaved,
      window.$mm_management_units_token
    );

    await GC.waitProcess(
      "Plaats in uitvoering",
      null,
      selectedRowDefinition,
      context,
      selectedIds.length
    );
  };

  const WijzigStatusSaved = () => {
    GC.sleep(1500).then(() => {
      $("#plaats_in_uitvoering").modal("hide");
      window.$mm_work_plans_refresh();
      /*omnimap
        .FillTableAction(
          window.$mm_work_plans_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  };
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="plaats_in_uitvoering"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Plaats in uitvoering</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <h1>Toelichting</h1>
            <p>
              Door op 'Verwerken' te klikken zal de werkregel naar de Gisratio
              app verstuurd worden.
            </p>
          </div>
          <div className="modal-footer">
            <MyContext.Consumer>
              {(context) => (
                <button
                  type="button"
                  className="btn-modal"
                  onClick={(event) => {
                    context.actions.actionStartProcess({
                      successRowCount:
                        window.$mm_work_plans_table_selected_row_count,
                      errorRowCount: 0,
                      completeSuccess: true,
                      completeError: false,
                      errorRowCodes: [],
                    });
                    handleSubmit();
                  }}
                >
                  Verwerken
                </button>
              )}
            </MyContext.Consumer>
            {/* <button
              type="button"
              id="save_plaats_in_uitvoering"
              className="btn-modal"
              onClick={handleSubmit.bind(this)}
            >
              Verwerken
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveerMaatregelModal;
